'use client'

import PropTypes from 'prop-types'
import { ClientMatterDetailsMenuItem } from '@repo/ui/ClientMatterDetailsMenuItem'
import { useState, useEffect } from 'react'
import { useCustomDataPageStore } from '@repo/store/useCustomDataPageStore'

export const ExtensionField = ({ field, index, extension, width = 'auto' }) => {
  const { getRenderedValueOfCustomDataField } = useCustomDataPageStore()
  const [renderedValue, setRenderedValue] = useState('')

  useEffect(() => {
    const { dataType } = field || {}
    let value = null

    if (extension?.values?.length) {
      extension?.values.forEach((item) => {
        if (item?.fieldId === field?.fieldId) {
          value = item?.value
        }
      })
    }

    const getValueToRender = async () => {
      const renderValue = await getRenderedValueOfCustomDataField({
        fieldType: dataType,
        value
      })
      setRenderedValue(renderValue)
    }

    getValueToRender()
  }, [field, renderedValue, getRenderedValueOfCustomDataField, index, extension])

  const isMultiline =
    field?.fieldType === 'Multiline' ||
    field?.fieldType === 'Address' ||
    field?.fieldType === 'Contact' ||
    field?.fieldType === 'Organisation' ||
    field?.fieldType === 'Org'
  return (
    <ClientMatterDetailsMenuItem
      title={field?.description}
      width={width}
      label={renderedValue}
      variant="large"
      noWrap={!isMultiline}
    />
  )
}

ExtensionField.propTypes = {
  field: PropTypes.object,
  index: PropTypes.number,
  extension: PropTypes.object,
  width: PropTypes.any
}
